'use client';
// Icon components - these are typically static
export { CatIconArrowExpand } from '@blocks-react/components/Icons/ArrowExpand';
export { CatIconHealth } from '@blocks-react/components/Icons/Health';
export { CatIconMachineExcavator } from '@blocks-react/components/Icons/MachineExcavator';
export { CatIconSupportHeadphones } from '@blocks-react/components/Icons/SupportHeadphones';
export { CatIconDownload } from '@blocks-react/components/Icons/Download';
export { CatIconSearch } from '@blocks-react/components/Icons/Search';
export { CatIconWrench } from '@blocks-react/components/Icons/Wrench';
export { CatIconCancelUndo } from '@blocks-react/components/Icons/CancelUndo';
export { CatIconCopy } from '@blocks-react/components/Icons/Copy';
export { CatIconCube } from '@blocks-react/components/Icons/Cube';
export { CatIconTask } from '@blocks-react/components/Icons/Task';
export { CatIconReplace } from '@blocks-react/components/Icons/Replace';
export { CatIconBrowserMultipleWindow } from '@blocks-react/components/Icons/BrowserMultipleWindow';
export { CatIconClose } from '@blocks-react/components/Icons/Close';
export { CatIconCustomer } from '@blocks-react/components/Icons/Customer';
export { CatIconEdit } from '@blocks-react/components/Icons/Edit';
export { CatIconHide } from '@blocks-react/components/Icons/Hide';
export { CatIconHelp } from '@blocks-react/components/Icons/Help';
export { CatIconSave } from '@blocks-react/components/Icons/Save';
export { CatIconShipping } from '@blocks-react/components/Icons/Shipping';
export { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
export { CatIconChevronLeft } from '@blocks-react/components/Icons/ChevronLeft';
export { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
export { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
export { CatIconFile } from '@blocks-react/components/Icons/File';
export { CatIconFlash } from '@blocks-react/components/Icons/Flash';
export { CatIconFilterLines } from '@blocks-react/components/Icons/FilterLines';
export { CatIconMoneySend } from '@blocks-react/components/Icons/MoneySend';
export { CatIconMinus } from '@blocks-react/components/Icons/Minus';
export { CatIconNotifications } from '@blocks-react/components/Icons/Notifications';
export { CatIconNotificationsFilled } from '@blocks-react/components/Icons/NotificationsFilled';
export { CatIconPhone } from '@blocks-react/components/Icons/Phone';
export { CatIconPrint } from '@blocks-react/components/Icons/Print';
export { CatIconProp65 } from '@blocks-react/components/Icons/Prop65';
export { CatIconTrash } from '@blocks-react/components/Icons/Trash';
export { CatIconShare } from '@blocks-react/components/Icons/Share';
export { CatIconShippingFast } from '@blocks-react/components/Icons/ShippingFast';
export { CatIconSettings } from '@blocks-react/components/Icons/Settings';
export { CatIconSuccessFilled } from '@blocks-react/components/Icons/SuccessFilled';
export { CatIconArrowForward } from '@blocks-react/components/Icons/ArrowForward';
export { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
export { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
export { CatIconMachineTractor } from '@blocks-react/components/Icons/MachineTractor';
export { CatIconShop } from '@blocks-react/components/Icons/Shop';
export { CatIconShopHistory } from '@blocks-react/components/Icons/ShopHistory';
export { CatIconShow } from '@blocks-react/components/Icons/Show';
export { CatIconControlCenter } from '@blocks-react/components/Icons/ControlCenter';
export { CatIconTrendingUp } from '@blocks-react/components/Icons/TrendingUp';
export { CatIconEngine } from '@blocks-react/components/Icons/Engine';
export { CatIconAddCircle } from '@blocks-react/components/Icons/AddCircle';
export { CatIconAdd } from '@blocks-react/components/Icons/Add';
export { CatIconFileUpload } from '@blocks-react/components/Icons/FileUpload';
export { CatIconStar } from '@blocks-react/components/Icons/Star';
export { CatIconStarFilled } from '@blocks-react/components/Icons/StarFilled';
export { CatIconInfo } from '@blocks-react/components/Icons/Info';
export { CatIconInfoFilled } from '@blocks-react/components/Icons/InfoFilled';
export { CatIconSuccess } from '@blocks-react/components/Icons/Success';
export { CatIconEllipsis } from '@blocks-react/components/Icons/Ellipsis';
export { CatIconExternalLinkBox } from '@blocks-react/components/Icons/ExternalLinkBox';
export { CatIconAttachment } from '@blocks-react/components/Icons/Attachment';
export { CatIconSend } from '@blocks-react/components/Icons/Send';
export { CatIconPlayCircleOutline } from '@blocks-react/components/Icons/PlayCircleOutline';
export { CatIconEmail } from '@blocks-react/components/Icons/Email';
export { CatIconMessage } from '@blocks-react/components/Icons/Message';
export { CatIconNote } from '@blocks-react/components/Icons/Note';
export { CatIconClock } from '@blocks-react/components/Icons/Clock';
export { CatIconTagFilled } from '@blocks-react/components/Icons/TagFilled';
export { CatIconTag } from '@blocks-react/components/Icons/Tag';
export { CatIconDashboard2 } from '@blocks-react/components/Icons/Dashboard2';
export { CatIconZoomIn } from '@blocks-react/components/Icons/ZoomIn';
export { CatIconZoomOut } from '@blocks-react/components/Icons/ZoomOut';
export { CatIconCva } from '@blocks-react/components/Icons/Cva';
export { CatIconShieldCheck } from '@blocks-react/components/Icons/ShieldCheck';
export { CatIconWarningDiamondFilled } from '@blocks-react/components/Icons/WarningDiamondFilled';
export { CatIconCreditCard } from '@blocks-react/components/Icons/CreditCard';
export { CatIconHyperlink } from '@blocks-react/components/Icons/Hyperlink';
export { CatIconLocation } from '@blocks-react/components/Icons/Location';
export { CatIconLanguage } from '@blocks-react/components/Icons/Language';
export { CatIconPdf } from '@blocks-react/components/Icons/Pdf';
export { CatIconTools } from '@blocks-react/components/Icons/Tools';
export { CatIconSwap } from '@blocks-react/components/Icons/Swap';
export { CatIconBox } from '@blocks-react/components/Icons/Box';
export { CatIconScale } from '@blocks-react/components/Icons/Scale';
export { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
export { CatIconWarningCircleFilled } from '@blocks-react/components/Icons/WarningCircleFilled';
export { CatIconMenuDots } from '@blocks-react/components/Icons/MenuDots';
export { CatIconCheck } from '@blocks-react/components/Icons/Check';
export { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
export { CatIconWarningTriangleFilled } from '@blocks-react/components/Icons/WarningTriangleFilled';
export { CatIconArrowTriangularRight } from '@blocks-react/components/Icons/ArrowTriangularRight';
export { CatIconArrowTriangularLeft } from '@blocks-react/components/Icons/ArrowTriangularLeft';
export { CatIconCalendarClock } from '@blocks-react/components/Icons/CalendarClock';
export { CatIconUndo } from '@blocks-react/components/Icons/Undo';
export { CatIconToolbox } from '@blocks-react/components/Icons/Toolbox';
export { CatIconEditBox } from '@blocks-react/components/Icons/EditBox';
export { CatIconManual } from '@blocks-react/components/Icons/Manual';
export { CatIconPeople } from '@blocks-react/components/Icons/People';
export { CatIconLock } from '@blocks-react/components/Icons/Lock';
export { CatIconDealer } from '@blocks-react/components/Icons/Dealer';
export { CatIconWifi } from '@blocks-react/components/Icons/Wifi';
export { CatIconNoWifi } from '@blocks-react/components/Icons/NoWifi';
export { CatIconDocumentParts } from '@blocks-react/components/Icons/DocumentParts';
export { CatIconCircleFull } from '@blocks-react/components/Icons/CircleFull';
export { CatIconTriangleFilled } from '@blocks-react/components/Icons/TriangleFilled';
export { CatIconDiamondFilled } from '@blocks-react/components/Icons/DiamondFilled';
